import { CertificateProgram, CertificateProgramEngagement } from '@mc/api'
import { useBucket } from '@mc/experiments-react'
import { useIsSubscriptionsExpEligible } from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import {
  MCCERTS_2972_SUBS_ONLY_CLP_FLAG,
  type SubsOnlyClpBucket,
} from '../constants'

export type SubsOnlyClpExpEligibilityProps = {
  engagement?: CertificateProgramEngagement
  program: CertificateProgram
  isPaintedDoor?: boolean
}

// The flag's default value is `{}` (no bucket), so only visitors assigned by
// the experiment rule get one; everyone else keeps the mccerts-2548_v1 surfaces.
export const useSubsOnlyClpExpBucket = ({
  engagement,
  program,
  isPaintedDoor,
}: SubsOnlyClpExpEligibilityProps): SubsOnlyClpBucket | undefined => {
  const isEligible = useIsSubscriptionsExpEligible({
    engagement,
    program,
    isPaintedDoor,
  })
  const bucket = useBucket<SubsOnlyClpBucket>(MCCERTS_2972_SUBS_ONLY_CLP_FLAG)
  return isEligible && bucket ? bucket : undefined
}

export const useIsSubsOnlyClpExpActive = (
  props: SubsOnlyClpExpEligibilityProps,
): boolean => !!useSubsOnlyClpExpBucket(props)
